import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import Dividends from './Dividends';
import Buy from './Buy';
import RecycleBin from './RecycleBin';
import Msft from './Msft';
import Payday from './Payday';
import Verify from './Verify';
import Network from './Network';
import Mission from './Mission';
import Casino from './Casino';
import Zone from './Zone';
import { LIVE as CASINO_LIVE, PRACTICE as CASINO_PRACTICE } from 'lib/casino';
import missionIcon from 'assets/windowsIcons/57(32x32).png';
import casinoIcon from 'assets/windowsIcons/solitaire.png';
import xIcon from 'assets/windowsIcons/x.svg';
import telegramIcon from 'assets/windowsIcons/telegram.svg';

// Where the internet talks. Desktop icons and Start-menu rows open these in a new tab.
export const SOCIAL = {
  x: 'https://x.com/internetcoin888',
  telegram: 'https://t.me/internetcoinRH',
};
import zoneIcon from 'assets/windowsIcons/msn.png';
import msftIcon from 'assets/windowsIcons/74(32x32).png';
import paydayIcon from 'assets/windowsIcons/mail.png';
import verifyIcon from 'assets/windowsIcons/67(32x32).png';
import networkIcon from 'assets/windowsIcons/309(32x32).png';
import dontIcon from 'assets/windowsIcons/897(32x32).png';
import Messenger from './Messenger';
import Archive from './Archive';
import Pinball from './Pinball';
import Games from './Games';
import Arcade from './Arcade';
import Movies from './Movies';
import Cmd from './Cmd';
import Pictures from './Pictures';
import picturesIcon from 'assets/windowsIcons/307(32x32).png';
import Run from './Run';
import Basement from './Basement';
import { isUnlocked } from './Basement/state';
import runIcon from 'assets/windowsIcons/743(32x32).png';
import basementIcon from 'assets/windowsIcons/310(32x32).png';
import gamesIcon from 'assets/windowsIcons/358(32x32).png';
import gamesIconSmall from 'assets/windowsIcons/358(16x16).png';
import wmpIcon from 'assets/windowsIcons/846(32x32).png';
import wmpIconSmall from 'assets/windowsIcons/846(16x16).png';
import cmdIcon from 'assets/windowsIcons/743(32x32).png';
import cmdIconSmall from 'assets/windowsIcons/56(16x16).png';
import timeIcon from 'assets/windowsIcons/history.png';
import pinballIcon from 'assets/windowsIcons/pinball.png';
import videosIcon from 'assets/windowsIcons/myvideos.png';
import videosIconSmall from 'assets/windowsIcons/myvideos16.png';
import msnIcon from 'assets/windowsIcons/msn.png';
import dividendsIcon from 'assets/windowsIcons/546(32x32).png';
import buyIcon from 'assets/windowsIcons/549(32x32).png';
import recycleIcon from 'assets/windowsIcons/147(32x32).png';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ie from 'assets/windowsIcons/ie.png';
import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';

// DO NOT OPEN has no window of its own — WinXP/index.js intercepts it and spawns the error cascade.
export const DoNotOpen = () => null;

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
  {
    component: InternetExplorer,
    header: {
      title: 'Internet Explorer',
      icon: iePaper,
    },
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 130,
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Minesweeper,
    header: {
      title: 'Minesweeper',
      icon: mine,
    },
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 180,
      y: 170,
    },
    resizable: false,
    minimized: window.innerWidth < 800, // phones: keep the IE homepage as the first screen
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Winamp,
    header: {
      title: 'Winamp',
      icon: winamp,
      invisible: true,
    },
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Msft,
    header: {
      title: 'MSFT.exe',
      icon: msftIcon,
    },
    defaultSize: {
      width: 500,
      height: 620,
    },
    defaultOffset: {
      x: Math.min(470, Math.max(20, window.innerWidth - 920)),
      y: 110,
    },
    resizable: true,
    minimized: window.innerWidth < 800,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
];

// My Videos — the lime archive is open the moment the desktop boots (XP Filmstrip view).
// Pushed before Messenger so the chat keeps top focus; placed left of it so they don't overlap.
defaultAppState.push({
  component: Archive,
  header: {
    title: 'My Videos',
    icon: videosIconSmall,
  },
  defaultSize: {
    width: 720,
    height: 540,
  },
  defaultOffset: {
    x: Math.max(40, Math.min(200, window.innerWidth - 1160)),
    y: 110,
  },
  resizable: true,
  // phones: parked in the taskbar so the IE pitch stays the first screen (site convention)
  minimized: window.innerWidth < 800,
  maximized: window.innerWidth < 800,
  id: genId(),
  zIndex: genIndex(),
});

// Windows Messenger signs in at boot on desktop-sized viewports (like the real XP tray).
if (window.innerWidth >= 800) {
  defaultAppState.push({
    component: Messenger,
    header: {
      title: 'Windows Messenger',
      icon: msnIcon,
    },
    defaultSize: {
      width: 400,
      height: 480,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth - 430),
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  });
}

export const defaultIconState = [
  {
    id: 0,
    icon: ie,
    title: 'The Internet',
    component: InternetExplorer,
    isFocus: false,
  },
  {
    id: 30,
    icon: timeIcon,
    title: 'Time Machine',
    component: InternetExplorer,
    app: 'Time Machine',
    isFocus: false,
  },
  {
    id: 1,
    icon: dividendsIcon,
    title: 'DIVIDENDS.exe',
    component: Dividends,
    isFocus: false,
  },
  {
    id: 2,
    icon: buyIcon,
    title: 'BUY $INTERNET',
    component: Buy,
    isFocus: false,
  },
  {
    id: 34,
    icon: zoneIcon,
    title: 'THE ZONE',
    component: Zone,
    isFocus: false,
  },
  {
    id: 40,
    icon: xIcon,
    title: 'X (@internetcoin888)',
    component: null,
    href: SOCIAL.x,
    isFocus: false,
  },
  {
    id: 41,
    icon: telegramIcon,
    title: 'Telegram',
    component: null,
    href: SOCIAL.telegram,
    isFocus: false,
  },
  {
    id: 19,
    icon: missionIcon,
    title: 'MISSION.exe',
    component: Mission,
    isFocus: false,
  },
  {
    id: 20,
    icon: msftIcon,
    title: 'MSFT.exe',
    component: Msft,
    isFocus: false,
  },
  {
    id: 21,
    icon: paydayIcon,
    title: 'PAYDAY.exe',
    component: Payday,
    isFocus: false,
  },
  {
    id: 22,
    icon: verifyIcon,
    title: 'VERIFY.exe',
    component: Verify,
    isFocus: false,
  },
  {
    id: 23,
    icon: networkIcon,
    title: 'Network Neighborhood',
    component: Network,
    isFocus: false,
  },
  {
    id: 3,
    icon: notepadLarge,
    title: 'README.txt',
    component: Notepad,
    isFocus: false,
  },
  {
    id: 4,
    icon: computerLarge,
    title: 'My Computer',
    component: MyComputer,
    isFocus: false,
  },
  {
    id: 25,
    icon: videosIcon,
    title: 'My Videos',
    component: Archive,
    isFocus: false,
  },
  {
    id: 32,
    icon: picturesIcon,
    title: 'My Pictures',
    component: Pictures,
    isFocus: false,
  },
  {
    id: 28,
    icon: wmpIcon,
    title: 'Old Movies',
    component: Movies,
    isFocus: false,
  },
  {
    id: 26,
    icon: pinballIcon,
    title: '3D Pinball',
    component: Pinball,
    isFocus: false,
  },
  {
    id: 27,
    icon: gamesIcon,
    title: 'Games',
    component: Games,
    isFocus: false,
  },
  {
    id: 5,
    icon: mine,
    title: 'Minesweeper',
    component: Minesweeper,
    isFocus: false,
  },
  {
    id: 6,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 7,
    icon: paintLarge,
    title: 'Paint',
    component: Paint,
    isFocus: false,
  },
  {
    id: 29,
    icon: cmdIcon,
    title: 'Command Prompt',
    component: Cmd,
    isFocus: false,
  },
  {
    id: 24,
    icon: dontIcon,
    title: 'DO NOT OPEN',
    component: DoNotOpen,
    isFocus: false,
  },
  {
    id: 8,
    icon: recycleIcon,
    title: 'Recycle Bin',
    component: RecycleBin,
    isFocus: false,
  },
  {
    id: 9,
    icon: msnIcon,
    title: 'Windows Messenger',
    component: Messenger,
    isFocus: false,
  },
];

// ARG level 1: BASEMENT.exe only exists on desktops where the key has turned (see Basement/state.js).
export const basementIconEntry = {
  id: 31,
  icon: basementIcon,
  title: 'BASEMENT.exe',
  component: Basement,
  isFocus: false,
};
if (isUnlocked()) defaultIconState.push(basementIconEntry);

// CASINO.exe is dark until the cabinets are deployed. `LIVE` is false while every address in
// lib/casino.js is the zero address, so publishing the site ships THE ZONE and nothing of the
// casino. deploy.ts --live writes the addresses and the icon appears on the next build.
export const casinoIconEntry = {
  id: 33,
  icon: casinoIcon,
  title: 'CASINO.exe',
  component: Casino,
  isFocus: false,
};
// Withheld while the floor is dark. Once it can take a bet — real chips or practice play money —
// it goes in the first column right under BUY $INTERNET: the top four slots sit behind the Winamp
// stack the boot opens, so the fifth slot is the first one a fresh boot actually shows.
if (CASINO_LIVE || CASINO_PRACTICE) {
  const after = defaultIconState.findIndex(i => i.title === 'BUY $INTERNET');
  defaultIconState.splice(after < 0 ? 1 : after + 1, 0, casinoIconEntry);
}

export const appSettings = {
  // ——— community round 1 (2026-09-08): games, old movies, time machine, cmd.exe, Run…, the basement ———
  Run: {
    header: {
      icon: cmdIconSmall,
      title: 'Run',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: Run,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: 12,
      y: Math.max(40, window.innerHeight - 190),
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Basement: {
    header: {
      icon: basementIcon,
      title: 'BASEMENT.exe',
    },
    component: Basement,
    defaultSize: {
      width: 720,
      height: 620,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(240, window.innerWidth - 900)),
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Games: {
    header: {
      icon: gamesIconSmall,
      title: 'Games',
    },
    component: Games,
    defaultSize: {
      width: 780,
      height: 540,
    },
    defaultOffset: {
      x: Math.max(30, Math.min(220, window.innerWidth - 1020)),
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Arcade: {
    header: {
      icon: gamesIconSmall,
      title: 'Games',
    },
    component: Arcade,
    defaultSize: {
      width: 680,
      height: 570,
    },
    defaultOffset: {
      x: Math.max(30, Math.min(300, window.innerWidth - 940)),
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'My Pictures': {
    header: {
      icon: picturesIcon,
      title: 'My Pictures',
    },
    component: Pictures,
    defaultSize: {
      width: 820,
      height: 560,
    },
    defaultOffset: {
      x: Math.max(30, Math.min(180, window.innerWidth - 1060)),
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Windows Media Player': {
    header: {
      icon: wmpIconSmall,
      title: 'Windows Media Player',
    },
    component: Movies,
    defaultSize: {
      width: 860,
      height: 580,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(180, window.innerWidth - 1080)),
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Command Prompt': {
    header: {
      icon: cmdIconSmall,
      title: 'C:\\WINDOWS\\system32\\cmd.exe',
    },
    component: Cmd,
    defaultSize: {
      width: 680,
      height: 400,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(260, window.innerWidth - 900)),
      y: 140,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'Time Machine': {
    header: {
      icon: iePaper,
      title: 'Time Machine - Internet Explorer',
    },
    component: InternetExplorer,
    injectProps: { startUrl: 'google.com', startYear: 2003 },
    instanceKey: 'time-machine',
    defaultSize: {
      width: 800,
      height: 560,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(160, window.innerWidth - 1000)),
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Pinball: {
    header: {
      icon: pinballIcon,
      title: '3D Pinball for Windows - Space Cadet',
    },
    component: Pinball,
    defaultSize: {
      width: 640,
      height: 560,
    },
    defaultOffset: {
      x: Math.max(40, Math.min(260, window.innerWidth - 1100)),
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Mission: {
    header: {
      icon: missionIcon,
      title: 'MISSION.exe',
    },
    component: Mission,
    defaultSize: {
      width: 600,
      height: 640,
    },
    defaultOffset: {
      x: 340,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'My Videos': {
    header: {
      icon: videosIconSmall,
      title: 'My Videos',
    },
    component: Archive,
    defaultSize: {
      width: 720,
      height: 540,
    },
    defaultOffset: {
      x: Math.max(40, Math.min(200, window.innerWidth - 1160)),
      y: 110,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  'Windows Messenger': {
    header: {
      icon: msnIcon,
      title: 'Windows Messenger',
    },
    component: Messenger,
    defaultSize: {
      width: 400,
      height: 480,
    },
    defaultOffset: {
      x: Math.max(20, window.innerWidth - 430),
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Msft: {
    header: {
      icon: msftIcon,
      title: 'MSFT.exe',
    },
    component: Msft,
    defaultSize: {
      width: 440,
      height: 470,
    },
    defaultOffset: {
      x: Math.max(120, window.innerWidth - 500),
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Payday: {
    header: {
      icon: paydayIcon,
      title: 'PAYDAY.exe',
    },
    component: Payday,
    defaultSize: {
      width: 620,
      height: 660,
    },
    defaultOffset: {
      x: 360,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Verify: {
    header: {
      icon: verifyIcon,
      title: 'VERIFY.exe',
    },
    component: Verify,
    defaultSize: {
      width: 620,
      height: 620,
    },
    defaultOffset: {
      x: 300,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Network: {
    header: {
      icon: networkIcon,
      title: 'Network Neighborhood',
    },
    component: Network,
    defaultSize: {
      width: 560,
      height: 620,
    },
    defaultOffset: {
      x: 280,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Dividends: {
    header: {
      icon: dividendsIcon,
      title: 'DIVIDENDS.exe',
    },
    component: Dividends,
    defaultSize: {
      width: 700,
      height: 580,
    },
    defaultOffset: {
      x: 430,
      y: 140,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Buy: {
    header: {
      icon: buyIcon,
      title: 'BUY $INTERNET',
    },
    component: Buy,
    defaultSize: {
      width: 660,
      height: 600,
    },
    defaultOffset: {
      x: 320,
      y: 100,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  'Recycle Bin': {
    header: {
      icon: recycleIcon,
      title: 'Recycle Bin',
    },
    component: RecycleBin,
    defaultSize: {
      width: 520,
      height: 320,
    },
    defaultOffset: {
      x: 300,
      y: 180,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'The Internet - Internet Explorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'README.txt - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Zone: {
    header: {
      icon: zoneIcon,
      title: 'THE ZONE',
    },
    component: Zone,
    defaultSize: {
      width: 470,
      height: 640,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(360, window.innerWidth - 560)),
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Casino: {
    header: {
      icon: casinoIcon,
      title: 'CASINO.exe',
    },
    component: Casino,
    defaultSize: {
      width: 620,
      height: 700,
    },
    defaultOffset: {
      x: Math.max(20, Math.min(300, window.innerWidth - 760)),
      y: 18,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
};

export { InternetExplorer, Minesweeper, ErrorBox, MyComputer, Notepad, Winamp };


// ── boot ─────────────────────────────────────────────────────────────────────
//
// What opens when the desktop loads. On a 390px phone the default set (IE, Minesweeper, Winamp
// with its EQ and playlist, MSFT.exe, the archive) buries the screen before a player has done
// anything; and ?app=casino is a link straight onto the floor — the thread, the MetaMask deep
// link and anyone who just wants to play all land there. Read at call time, so it sees the real
// viewport and URL rather than whatever they were at module load.
export function casinoDirect() {
  if (typeof window === 'undefined') return false;
  const q = new URLSearchParams(window.location.search);
  return q.get('app') === 'casino' || window.location.hash === '#casino';
}

export function bootApps() {
  if (casinoDirect()) {
    // appSettings entries are templates; a booted window also needs the id and z-index the
    // reducer would otherwise assign in ADD_APP.
    return [{ ...appSettings.Casino, maximized: true, minimized: false, id: genId(), zIndex: genIndex() }];
  }
  const small = typeof window !== 'undefined' && window.innerWidth < 800;
  if (!small) return defaultAppState;
  // Phones: keep the landing page, drop the toys that only make sense with a mouse.
  const keep = new Set([InternetExplorer]);
  return defaultAppState.filter(app => keep.has(app.component));
}
